define('core/extensions/helpers/gettext',[
    'handlebars',

    'core/strings',
], function (
    Handlebars,

    strings
) {
    'use strict';

    /*
     * @gettext helper process translatable strings.
     * Examples:
     *   - simply replace string with its translation:
     *
     *     {{gettext "translate me please"}}
     *
     *   - replace string with its translation, in addition replace @name placeholder
     *     with html generated by partial template with @partialName. Partial executed
     *     with @context:
     *
     *     {{gettext "%(name)s translate me please" name = partialName(context)}}
     *
     *   - replace string with its translation, in addition replace @number placeholder with value of @count
     *
     *     {{gettext "%(number)s comments" number = count}}
     *
     */
    return function () {
        var len = arguments.length;
        var options = arguments[len - 1];
        var hash = options.hash;
        var value = arguments[0];
        var partials = Handlebars.partials;
        var html, regex, key, isPartial;

        value = Handlebars.Utils.escapeExpression(strings.get(value));
        for (key in hash) {
            if (hash.hasOwnProperty(key)) {
                regex = new RegExp('%\\((' + key + ')\\)s', 'gm');
                html = hash[key];
                isPartial = html && html.executePartial;

                if (isPartial)
                    html = partials[html.partial].call(this, html.context, options);

                // replace undefined, null and NaN with empty string
                if (html === undefined || html === null || (typeof html === 'number' && isNaN(html)))
                    html = '';
                else if (!isPartial)
                    html = Handlebars.Utils.escapeExpression(html);

                value = value.replace(regex, html.toString());
            }
        }
        return new Handlebars.SafeString(value);
    };
});

